// extracted by mini-css-extract-plugin
export default {"modal_container":"Modal_modal_container__WtfSn","modal_close":"Modal_modal_close__DT8Wk"};